export default {
  //设置token
  setToken(state, p) {
    state.token = p
  },
  //设置index
  setIndexName(state, p) {
    state.indexName = p
  },
  //设置表格数据
  setTableData(state, p) {
    console.log('p',p)
    state.tableData = p
  },
  //设置总共数据条数
  setTotal(state, p) {
    state.total = p.total
  },
  //设置车系下拉框所需字段
  setCarSeries(state, p) {
    state.car_series_list = []
    state.car_group_list = []
    state.car_kind_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].carClassID,
        label: p[i].carClassName
      }
      state.car_series_list.push(obj)
    }
  },
  //设置车组下拉框所需字段
  setCarGroup(state, p) {
    console.log(state,p,'ppppppppppppppppppppppppppppppp')
    state.car_group_list = []
    state.car_kind_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].carGroupID,
        label: p[i].carGroupName
      }
      state.car_group_list.push(obj)
    }
  },
  //设置车型下拉框所需字段
  setCarKind(state, p) {
    state.car_kind_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].carKindID,
        label: p[i].carKindName
      }
      state.car_kind_list.push(obj)
    }
  },
  //设置车表图片类型下拉框所需字段
  setIconList(state, p) {
    state.iconTypeID_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].iconTypeID,
        label: p[i].name
      }
      state.iconTypeID_list.push(obj)
    }
  },



  //设置售机类型下拉框所需字段
  setEquipType(state, p) {
    state.equip_type_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      // if(p[i].productClassID != 24){
      obj = {
        value: p[i].productClassID,
        label: p[i].productClassName
      }
      state.equip_type_list.push(obj)
      // }

    }
  },
  //设置售机类型(去掉重复路径)下拉框所需字段
  setEquipTypeUnique(state, p) {
    state.equip_typeUnique_list = []
    state.equip_xinghao_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].path,
        label: p[i].productClassName
      }
      state.equip_typeUnique_list.push(obj)
    }
  },


  //设置语言下拉框所需字段(获取语言列表)
  setLanguageList(state, p) {
    state.lang_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].langid,
        label: p[i].cnname
      }
      state.lang_list.push(obj)
    }
  },
  //获取语言项列表下拉框（包含all项）
  setLanguageListAll(state, p) {
    state.lang_list_all = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].langid,
        label: p[i].cnname
      }
      state.lang_list_all.push(obj)
    }
  },

  //设置语言下拉框所需字段(获取所有语言列表)
  setLanguageAll(state, p) {
    state.all_lang_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].langid,
        label: p[i].cnname
      }
      state.all_lang_list.push(obj)
    }
  },
  //设置设备机型ID
  setProductID(state, p) {
    state.productInfoID = p
  },
  setCarKindIDs(state, p) {
    state.carKindIDs = p
  },

  //设置语言下拉框所需字段(获取所有语言列表)
  setAllLanguageAll(state, p) {
    state.all_lang_list_all = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].langid,
        label: p[i].cnname
      }
      state.all_lang_list_all.push(obj)
    }
  },

  //设置拓展文件信息下拉框所需字段
  setFileInfoAll(state, p) {
    state.fileInfo_all = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].extFileInfoID,
        label: p[i].extFileName
      }
      state.fileInfo_all.push(obj)
    }
  },


  //设置拓展文件信息下拉框所需字段
  setOtherfileList(state, p) {
    state.fileapp_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].fileTypeID,
        label: p[i].fileTypeName
      }
      state.fileapp_list.push(obj)
    }
  },

  setCheckTypeList(state, p) {
    state.checkType_list = []
    let obj = {}
    for (let i = 0; i < p.length; i++) {
      obj = {
        value: p[i].checktypeid,
        label: p[i].checktypename
      }
      state.checkType_list.push(obj)
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js